import HandIcon from 'assets/images/easyPay/init.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import DotsLoading from 'components/loadings/dotsLoading'
import useSetInitTransaction from './hooks/useSetInitTransaction'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import Footer from './footer'
import { MoneyPoolTransactionTypes } from '../../../utilities/helper/moneyPools'
import Switch from 'react-switch'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import {
    getActiveGateways,
    useActiveGatewayCode,
} from 'utilities/hooks/useIsDefaultGateway'

export default function Transaction() {
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const [payment, setPayment] = useState<number>(0)
    const [jsonData, setJsonData] = useState<any>([])
    const [lackOfWallet, setLackOfWallet] = useState<number>(0)
    const { state } = useLocation()
    const { data, isLoading } = useSetInitTransaction(
        state?.poolShipId,
        state?.formikValue?.type,
        state?.formikValue?.amount
    )
    const navigate = useNavigate()
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data: walletData } = useGetInitPaymentOs(
        profile?.id,
        Number(data?.commission),
        Number(payment)
    )
    const [selectedCode, setSelectedCode] = useState<string | null>(null)
    const activeGateways = getActiveGateways(data)
    useActiveGatewayCode(data, setSelectedCode)

    useEffect(() => {
        if (data) {
            setPayment(Number(state?.formikValue?.amount))
        }
    }, [data])

    useEffect(() => {
        if (data && payment) {
            if (isWallet) {
                if (Number(walletData?.wallet_balance) >= Number(payment)) {
                    setLackOfWallet(0)
                }
                if (Number(walletData?.wallet_balance) < Number(payment)) {
                    setLackOfWallet(
                        Number(payment) +
                            Number(data.commission) -
                            Number(walletData?.wallet_balance)
                    )
                }
            } else {
                setLackOfWallet(Number(payment) + Number(data.commission))
            }
        }
    }, [data, payment, isWallet])

    useEffect(() => {
        if (payment && state?.moneyPoolId && data && state) {
            setJsonData([
                {
                    moneyPool: Number(state?.moneyPoolId),
                    amount: Number(payment) + Number(data.commission),
                    ctxId: Number(state?.moneyPoolId),
                    gateway: selectedCode === 'SMN_MPG' ? 5 : 9,
                    receiver: data.receivers[0].id,
                    poolShip: state?.poolShipId,
                    trustState: state.trustState,
                    commission: Number(data.commission),
                    source: 'hwt',
                },
            ])
        }
    }, [payment, data, state, lackOfWallet])

    return (
        <div className=" h-screen relative flex flex-col">
            {data && state && !isLoading ? (
                <>
                    <div className=" my-3 px-4 grow-0">
                        <img
                            src={BackIcon}
                            alt="back"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                    <div className=" grow">
                        <div className="">
                            <>
                                <div className="">
                                    <img
                                        src={HandIcon}
                                        alt="hand"
                                        className=" mx-auto -mb-24 -z-50"
                                    />
                                    <div className="  bg-white shadow-soft rounded-xl px-3 pt-3 pb-8 mx-4 mt-16 min-h-[60%] overflow-y-auto ">
                                        <div className=" flex justify-between mt-4">
                                            <p className="">مبلغ:</p>
                                            <p>
                                                {Number(
                                                    state?.formikValue?.amount
                                                ).toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <p className="">هزینه اشتراک:</p>
                                            <p>
                                                {data.commission.toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> بابت:</p>
                                            <p>
                                                {
                                                    MoneyPoolTransactionTypes[
                                                        state?.formikValue?.type
                                                    ]
                                                }
                                            </p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> نام صندوق:</p>
                                            <p>{state?.name} </p>
                                        </div>
                                        {state?.isPayingForOther &&
                                            state?.payerName && (
                                                <div className=" flex justify-between mt-4">
                                                    <p className="">
                                                        {' '}
                                                        پرداخت کننده:
                                                    </p>
                                                    <p>{state?.payerName}</p>
                                                </div>
                                            )}
                                        <div className=" flex justify-between mt-4">
                                            <div className="text-sm">
                                                <p>استفاده از کیف پول:</p>
                                                <p className=" text-text-gray">
                                                    {walletData &&
                                                        walletData?.wallet_balance &&
                                                        walletData?.wallet_balance.toLocaleString()}{' '}
                                                    تومان
                                                </p>
                                            </div>
                                            <Switch
                                                onChange={() =>
                                                    setIsWallet(!isWallet)
                                                }
                                                checked={isWallet}
                                                onColor="#75B844"
                                                onHandleColor="#EAEEF0"
                                                handleDiameter={25}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                height={30}
                                                width={60}
                                                className="react-switch"
                                                id="material-switch"
                                                offColor="#B6BCC8"
                                            />
                                        </div>
                                        <hr className=" my-4" />
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> مبلغ:</p>
                                            <p>
                                                {isWallet
                                                    ? Number(
                                                          lackOfWallet
                                                      ).toLocaleString()
                                                    : Number(
                                                          payment +
                                                              data.commission
                                                      ).toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                    </div>

                                    <div className=" w-full items-center text-center my-4">
                                        <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                            {activeGateways.map((gw) => (
                                                <img
                                                    key={gw.unique_code}
                                                    src={gw.img_url}
                                                    alt={gw.unique_code}
                                                    className={classNames(
                                                        'mx-2 cursor-pointer',
                                                        selectedCode === gw.unique_code
                                                            ? 'border-2 border-green-1 rounded-md'
                                                            : 'border-1 border-gray-4 rounded-md'
                                                    )}
                                                    onClick={() => setSelectedCode(gw.unique_code)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                    <div className=" grow -0 w-full">
                        <Footer
                            total={Number(state?.formikValue?.amount)}
                            commission={data.commission}
                            ctx_id={state?.poolShipId}
                            ctx_type="mnp"
                            destination={data.receivers[0].destination}
                            gateway={selectedCode === 'SMN_MPG' ? 5 : 9}
                            selectedGatewayCode={selectedCode}
                            reciever={data.receivers[0].id}
                            role={state?.role}
                            lackOfWallet={lackOfWallet}
                            isWallet={isWallet}
                            memberId={profile?.id}
                            payment={payment}
                            jsonData={jsonData}
                        />
                    </div>
                </>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
